'use client';

import Image from 'next/image';
import { Dialog } from '../Dialog';

/*ts ignore is required for successful build*/
// @ts-ignore
import ImageZoom from 'react-image-zooom';
import { ReactNode } from 'react';

export function ImageZoomable({
  src,
  alt,
  openElement = <Image src={src} width={1024} height={1024} alt={alt} />,
  openClasses,
}: {
  src: string;
  alt: string;
  openElement?: ReactNode;
  openClasses?: string;
}) {
  return (
    <Dialog
      openButtonContent={openElement}
      openButtonClass={openClasses}
      contentClass="w-11/12 max-w-7xl"
    >
      <ImageZoom src={src} alt={alt} className="h-auto! w-full!" />
    </Dialog>
  );
}
